import { BaseEntity } from './base-entity.model';

export class DamageReport extends BaseEntity<DamageReport> {
  firstname?: string;
  lastname?: string;
  location = 'arbeitsplatz';
  locationExtension?: string;
  description?: string;
}
